import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import RadioGroup from '@mui/material/RadioGroup';
import React from 'react';
import { Controller } from 'react-hook-form';
import { MyMRadio } from '../ui-elements/MyMRadio';

/**
 * 入力チェック用Radio Component
 */
const ValidatableRadio = ({
  row,
  radioList,
  control,
  name, rules,
  formState,
  onChange,
  // 2025.3.5 MyMine Version2.1対応 Add Start
  radioProps,
  checkValue,
  // 2025.3.5 MyMine Version2.1対応 Add End
  // 2025.7.7 MyMine Version3.0対応 Add Start
  renderOptionSuffixItem
  // 2025.7.7 MyMine Version3.0対応 Add End
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl error={formState.errors[name] ? true : false}>
          <RadioGroup
            row={row}
            {...field}
            // 2025.3.5 MyMine Version2.1対応 Modify Start
            value={checkValue ?? (field.value === undefined ? '' : field.value)}
            // 2025.3.5 MyMine Version2.1対応 Modify End
            onChange={((e) => {
              field.onChange(parseInt(e?.currentTarget.value))
              onChange && onChange(e);
            })}
          >
            {
              radioList.map((x) => {
                // 2025.7.7 MyMine Version3.0対応 Modify Start
                // 2025.3.5 MyMine Version2.1対応 Modify Start
                return (
                  <React.Fragment key={x.Key}>
                    <MyMRadio value={x.Key} label={x.Value} {...radioProps} />
                    {renderOptionSuffixItem && renderOptionSuffixItem(x)}
                  </React.Fragment>
                )
                // 2025.3.5 MyMine Version2.1対応 Modify End
                // 2025.7.7 MyMine Version3.0対応 Modify End
              })
            }
          </RadioGroup>
          <FormHelperText>{formState.errors[name]?.message}</FormHelperText>
        </FormControl>
      )}
      rules={rules}
    />
  );
};
export default ValidatableRadio;
